module.exports = "/assets/925e35ea75bb67dbbdec1c2d176581f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/J3.png
// module id = 2620
// module chunks = 0